/**
 * AG Grid's Quartz icons (ag-grid-community 36, `iconSetQuartzRegular`), path
 * for path: 24×24 outlines drawn at the theme's 16px icon size with a 1.5px
 * stroke that does not scale. The registration grid shows AG Grid's own sort,
 * filter and expand icons, not look-alikes.
 */
export const GRID_ICON_PATHS = {
  asc: ['m5 12 7-7 7 7', 'M12 19V5'],
  desc: ['M12 5v14', 'm19 12-7 7-7-7'],
  none: ['m7 15 5 5 5-5', 'm7 9 5-5 5 5'],
  filter: ['M3 6h18', 'M7 12h10', 'M10 18h4'],
  'tree-closed': ['m9 18 6-6-6-6'],
  'tree-open': ['m6 9 6 6 6-6'],
} as const

export type GridIconName = keyof typeof GRID_ICON_PATHS

/**
 * Quartz's checkbox marks, used as CSS masks: the tick (10×7) and the
 * indeterminate dash (10×2). A mask only takes the SVG's shape; the visible
 * color is the masked element's background, set from the tokens.
 */
export const CHECKBOX_TICK_MASK =
  'url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%277%27 fill=%27none%27%3E%3Cpath stroke=%27black%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.75%27 d=%27M1 3.5 3.5 6l5-5%27/%3E%3C/svg%3E")'

export const CHECKBOX_DASH_MASK =
  'url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%272%27 fill=%27none%27%3E%3Crect width=%2710%27 height=%272%27 fill=%27black%27 rx=%271%27/%3E%3C/svg%3E")'
